import styled from 'styled-components';

const Main = styled.div`
  background-color: #fff;
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
`;

export default Main;
